import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import {
  FETCH_OPERATOR_MASTER,
  GET_OPERATOR_MASTER,
  ADD_OPERATOR_MASTER,
  UPDATE_OPERATOR_MASTER,
  DELETE_OPERATOR_MASTER,
} from 'actions/operatorMaster';

function* fetchOperatorMaster(action) {
  try {
    const response = yield call(API.getOperatorMasters, action.payload);
    yield put({ type: FETCH_OPERATOR_MASTER.SUCCESS, payload: response.data });
    action.cb && action.cb(response.data);
  } catch (e) {
    yield put({ type: FETCH_OPERATOR_MASTER.FAIL, payload: { error: e } });
  }
}

function* getOperatorMasterById(action) {
  try {
    const response = yield call(API.getOperatorMasterById, action.payload);
    yield put({ type: GET_OPERATOR_MASTER.SUCCESS, payload: response.data });
    action.cb && action.cb(response.data);
  } catch (e) {
    yield put({ type: GET_OPERATOR_MASTER.FAIL, payload: { error: e } });
  }
}

function* createOperatorMaster(action) {
  try {
    const response = yield call(API.addOperatorMaster, action.payload);
    yield put({ type: ADD_OPERATOR_MASTER.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: ADD_OPERATOR_MASTER.FAIL, payload: { error: e } });
  }
}

function* updateOperatorMaster(action) {
  try {
    const response = yield call(API.updateOperatorMaster, action.payload);
    yield put({ type: UPDATE_OPERATOR_MASTER.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_OPERATOR_MASTER.FAIL, payload: { error: e } });
  }
}

function* deleteOperatorMaster(action) {
  try {
    const response = yield call(API.deleteOperatorMaster, action.payload);
    yield put({ type: DELETE_OPERATOR_MASTER.SUCCESS, payload: action.payload });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_OPERATOR_MASTER.FAIL, payload: { error: e } });
  }
}

function* operatorMaster() {
  yield takeLatest(FETCH_OPERATOR_MASTER.REQUEST, fetchOperatorMaster);
  yield takeLatest(GET_OPERATOR_MASTER.REQUEST, getOperatorMasterById);
  yield takeLatest(ADD_OPERATOR_MASTER.REQUEST, createOperatorMaster);
  yield takeLatest(UPDATE_OPERATOR_MASTER.REQUEST, updateOperatorMaster);
  yield takeLatest(DELETE_OPERATOR_MASTER.REQUEST, deleteOperatorMaster);
}

export default operatorMaster;
